/**
 * @generated SignedSource<<a0c7c2216d8c026d08c28368d7624686>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type messageDefinition_Refetch$variables = {
  id: string;
};
export type messageDefinition_Refetch$data = {
  readonly " $fragmentSpreads": FragmentRefs<"messageDefinitionForm_MessageDefinitionFragment">;
};
export type messageDefinition_Refetch = {
  response: messageDefinition_Refetch$data;
  variables: messageDefinition_Refetch$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "id"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "id"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "internalTitle",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "title",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "content",
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "url",
  "storageKey": null
},
v8 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v9 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "kind",
  "storageKey": null
},
v10 = {
  "alias": null,
  "args": null,
  "concreteType": "ImageElement",
  "kind": "LinkedField",
  "name": "element",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "File",
      "kind": "LinkedField",
      "name": "image",
      "plural": false,
      "selections": [
        (v8/*: any*/),
        (v3/*: any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "fileType",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "storageKey": null
},
v11 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "text",
  "storageKey": null
},
v12 = [
  (v11/*: any*/)
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "messageDefinition_Refetch",
    "selections": [
      {
        "args": (v1/*: any*/),
        "kind": "FragmentSpread",
        "name": "messageDefinitionForm_MessageDefinitionFragment"
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "messageDefinition_Refetch",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          (v3/*: any*/),
          {
            "kind": "InlineFragment",
            "selections": [
              (v4/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "showUntil",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "InAppNotification",
                "kind": "LinkedField",
                "name": "inAppNotification",
                "plural": false,
                "selections": [
                  (v5/*: any*/),
                  (v6/*: any*/)
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "DesktopNotification",
                "kind": "LinkedField",
                "name": "desktopNotification",
                "plural": false,
                "selections": [
                  (v5/*: any*/),
                  (v6/*: any*/),
                  (v7/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "File",
                    "kind": "LinkedField",
                    "name": "icon",
                    "plural": false,
                    "selections": [
                      (v3/*: any*/),
                      (v8/*: any*/)
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "MessageDefinitionPage",
                "kind": "LinkedField",
                "name": "pages",
                "plural": true,
                "selections": [
                  (v3/*: any*/),
                  (v4/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": null,
                    "kind": "LinkedField",
                    "name": "data",
                    "plural": false,
                    "selections": [
                      (v2/*: any*/),
                      (v9/*: any*/),
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          (v10/*: any*/)
                        ],
                        "type": "ImagePage",
                        "abstractKey": null
                      },
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": null,
                            "kind": "LinkedField",
                            "name": "button",
                            "plural": false,
                            "selections": [
                              (v2/*: any*/),
                              (v9/*: any*/),
                              {
                                "kind": "InlineFragment",
                                "selections": (v12/*: any*/),
                                "type": "ConfirmButton",
                                "abstractKey": null
                              },
                              {
                                "kind": "InlineFragment",
                                "selections": (v12/*: any*/),
                                "type": "TextCopyButton",
                                "abstractKey": null
                              },
                              {
                                "kind": "InlineFragment",
                                "selections": [
                                  (v11/*: any*/),
                                  (v7/*: any*/)
                                ],
                                "type": "LinkButton",
                                "abstractKey": null
                              }
                            ],
                            "storageKey": null
                          },
                          (v10/*: any*/)
                        ],
                        "type": "ImageWithButtonPage",
                        "abstractKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "type": "MessageDefinition",
            "abstractKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "58ffad14a0068b3f26ae6448a0bc4e69",
    "id": null,
    "metadata": {},
    "name": "messageDefinition_Refetch",
    "operationKind": "query",
    "text": "query messageDefinition_Refetch(\n  $id: ID!\n) {\n  ...messageDefinitionForm_MessageDefinitionFragment_1Bmzm5\n}\n\nfragment desktopNotificationForm_DesktopNotificationFragment on MessageDefinition {\n  desktopNotification {\n    title\n    content\n    url\n    icon {\n      id\n      name\n    }\n  }\n}\n\nfragment inAppNotificationForm_InAppNotificationFragment on MessageDefinition {\n  inAppNotification {\n    title\n    content\n  }\n}\n\nfragment messageDefinitionForm_MessageDefinitionFragment_1Bmzm5 on Query {\n  node(id: $id) {\n    __typename\n    ... on MessageDefinition {\n      internalTitle\n      showUntil\n      inAppNotification {\n        title\n        content\n      }\n      desktopNotification {\n        title\n        content\n        url\n        icon {\n          id\n          name\n        }\n      }\n      ...inAppNotificationForm_InAppNotificationFragment\n      ...desktopNotificationForm_DesktopNotificationFragment\n      ...messagePagesEditor_PagesFragment\n    }\n    id\n  }\n}\n\nfragment messagePageFormDialog_PageFragment on MessageDefinitionPage {\n  internalTitle\n  ...messagePageForm_PageFragment\n}\n\nfragment messagePageForm_PageFragment on MessageDefinitionPage {\n  id\n  internalTitle\n  data {\n    __typename\n    kind\n    ... on ImagePage {\n      element {\n        image {\n          name\n          id\n          fileType\n        }\n      }\n    }\n    ... on ImageWithButtonPage {\n      ...pageButtonForm_ButtonFragment\n      button {\n        __typename\n        kind\n        ... on ConfirmButton {\n          text\n        }\n        ... on TextCopyButton {\n          text\n        }\n        ... on LinkButton {\n          text\n          url\n        }\n      }\n      element {\n        image {\n          name\n          id\n          fileType\n        }\n      }\n    }\n  }\n}\n\nfragment messagePagesEditor_PagesFragment on MessageDefinition {\n  pages {\n    id\n    internalTitle\n    data {\n      __typename\n      kind\n    }\n    ...messagePageFormDialog_PageFragment\n  }\n  id\n}\n\nfragment pageButtonForm_ButtonFragment on ImageWithButtonPage {\n  button {\n    __typename\n    kind\n    ... on ConfirmButton {\n      text\n    }\n    ... on TextCopyButton {\n      text\n    }\n    ... on LinkButton {\n      text\n      url\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "1350a737515df694a84cca8a394e8703";

export default node;
